"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftPresets = void 0;
const shift_preset_1 = require("./shift-preset");
class ShiftPresets {
    constructor(props) {
        this.props = props;
    }
    get id() {
        return `${this.tenantId}-shift-presets`;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get presets() {
        return this.props.shiftPresets
            .map((props) => shift_preset_1.ShiftPreset.fromProps(props))
            .sort((a, b) => a.name.localeCompare(b.name));
    }
    get names() {
        return new Set(this.presets.map((group) => group.name));
    }
    get namesSorted() {
        return [...this.names].sort();
    }
    get numPresets() {
        return this.props.shiftPresets.length;
    }
    findPresetWithName(name) {
        return this.presets.find((preset) => preset.name === name) || null;
    }
    hasPresetWithName(name) {
        return this.findPresetWithName(name) !== null;
    }
    mayAddPreset(preset) {
        return !this.hasPresetWithName(preset.name);
    }
    toProps() {
        return this.props;
    }
    static fromProps(props) {
        return new ShiftPresets(props);
    }
    static createEmpty(tenantId) {
        return new ShiftPresets({
            tenantId,
            shiftPresets: [],
        });
    }
    withPresetAdded(preset) {
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((p) => p.name !== preset.name)
                    .map((p) => p.toProps()),
                preset.toProps(),
            ],
        });
    }
    withPresetRemoved(presetName) {
        if (!this.hasPresetWithName(presetName)) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
            ],
        });
    }
    withPresetRenamed(oldName, newName) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(oldName)) === null || _a === void 0 ? void 0 : _a.withName(newName);
        if (newPreset == null || this.hasPresetWithName(newName)) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== oldName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetPriceChanged(presetName, newPrice) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withPrice(newPrice);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetLocationChanged(presetName, newLocation) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withLocation(newLocation);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetDescriptionChanged(presetName, newDescription) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withDescription(newDescription);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetCrewMembersCanAttendChanged(presetName, crewMembersCanAttend) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withCrewMembersCanAttend(crewMembersCanAttend);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetChildrenCanAttendChanged(presetName, childrenCanAttend) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withChildrenCanAttend(childrenCanAttend);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
    withPresetStartAndEndChanged(presetName, newTime) {
        var _a;
        const newPreset = (_a = this.findPresetWithName(presetName)) === null || _a === void 0 ? void 0 : _a.withStartAndEndTime(newTime);
        if (newPreset == null) {
            return this;
        }
        return ShiftPresets.fromProps({
            ...this.toProps(),
            shiftPresets: [
                ...this.presets
                    .filter((preset) => preset.name !== presetName)
                    .map((preset) => preset.toProps()),
                newPreset.toProps(),
            ],
        });
    }
}
exports.ShiftPresets = ShiftPresets;
//# sourceMappingURL=shift-presets.js.map